import { Table, Tbody, Td, Tr } from '@uswitch/spark.table'
import { Bold2 } from '@uswitch/spark.type'

import * as st from '../styles'

export const InfoTable = ({ heading, data }) => {
  return (
    <>
      <Bold2 sx={st.tableHeading}>{heading}</Bold2>
      <Table as='table' sx={st.infoTable}>
        <Tbody>
          {data.map((row, idx) => {
            const [label, value] = row
            return (
              <Tr key={idx} striped>
                <Td sx={st.tableLabel(label)}>{label}</Td>
                <Td sx={st.tableValue}>{value}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </>
  )
}
